export const UserErrorMessages = {
  IncorrectUsernameorPassword:
    'The supplied username and password combination was not recognised',
  'Popup window closed': 'Single sign on window was closed, please try again.',
} as { [errorMessage: string]: string };
